export interface Station {
  id: string;
  name?: string;
  brand?: StationBrand;
  latitude: number;
  longitude: number;
  phoneNumber?: string;
  address: StationAddress;
  services: StationServiceModel[];
  fuels: StationFuel[];
  loyaltyPrograms?: LoyaltyProgram[];
  fuelPrices?: FuelPrice[];
  openingHours?: OpeningHours;
  openingHoursStore?: OpeningHours;
  openingHoursFuel?: OpeningHours;
  // UI-specific fields
  distance?: number; // km from user (calculated)
  travelTime?: number; // minutes (calculated)
}

export interface StationsFilters {
  services: string[];
  fuels: string[];
  openNow: boolean;
  loyaltyPrograms?: string[];
}

export type OptionalGetStationsQueryParam = 'serviceNames' | 'fuelNames' | 'loyaltyPrograms';

export interface StationAddress {
  street: string;
  city: string;
  postalCode: string;
  state: string;
  country: string;
}

export interface StationServiceModel {
  displayName: string; // e.g., "EV Charging"
  name: string; // e.g., "NA_EVCHARGING"
}

export interface StationFuel {
  displayName: string; // e.g., "Diesel"
  name: string; // e.g., "NA_DIESEL"
}

export interface LoyaltyProgram {
  displayName: string; // e.g., "Inner Circle"
  name: string; // e.g., "INNER_CIRCLE"
}

export interface FuelPrice {
  code: string; // e.g., "UNL"
  price: number;
  currency: string; // e.g., "usd"
  volumeUnit: string; // e.g., "gallon"
  lastUpdated: string; // ISO date string
}

export interface OpeningHours {
  alwaysOpen?: boolean;
  sunday?: DayHours;
  monday?: DayHours;
  tuesday?: DayHours;
  wednesday?: DayHours;
  thursday?: DayHours;
  friday?: DayHours;
  saturday?: DayHours;
}

export interface DayHours {
  open: string; // e.g., "09:00"
  close: string; // e.g., "23:00"
}

export interface StationsResponse {
  stations: Station[];
}

export enum StationFeatureCategory {
  SERVICES = 'services',
  FUELS = 'fuels',
  TRUCK_SERVICES = 'truckServices',
}

export enum StationBrand {
  COUCHE_TARD = 'COUCHE_TARD',
  CIRCLEK = 'CIRCLEK',
}
